import React, { ReactNode } from "react";
import styled from "styled-components";

import { Button } from "./Button";
import { Close } from "./Icons";
import { BorderedInput } from "./Input";

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

type KeyValueItem = { key: string; value: string };

type Props = {
  items: Array<KeyValueItem>;
  addButton: ReactNode;
  onChange: (items: Array<KeyValueItem>) => void;
};

export const KeyValueListInput: React.FC<Props> = ({ items, addButton, onChange }) => {
  return (
    <List>
      {items.map((item, index) => (
        <Row key={index}>
          <BorderedInput
            name={`key_${index}`}
            value={item.key}
            placeholder="Key"
            onChange={e => {
              const value = e.target.value;

              const newItems = [...items];

              newItems[index].key = value;

              onChange(newItems);
            }}
          />

          <BorderedInput
            name={`value_${index}`}
            value={item.value}
            placeholder="Value"
            onChange={e => {
              const value = e.target.value;

              const newItems = [...items];

              newItems[index].value = value;

              onChange(newItems);
            }}
          />

          <Button
            size="small"
            type="text"
            onClick={() => {
              const newItems = [...items];

              newItems.splice(index, 1);

              onChange(newItems);
            }}
          >
            <Close height="8px" width="8px" />
          </Button>
        </Row>
      ))}

      {addButton}
    </List>
  );
};

export default KeyValueListInput;
